import { HashRouter as Router, Switch } from "react-router-dom";

import {useFirebaseProject, FirebaseContext} from "@meddbriefer/mdb-firebase"
import { AuthProvider, PrivateRoute } from "@meddbriefer/mdb-auth";
import { ObserverContext, PreferencesProvider, Scenario, ScenarioList, UnauthedLayout } from "@meddbriefer/observer-ui"

import { environment } from "./environments/environment"


export default function App(props) {
    const {auth, db} = useFirebaseProject(environment.firebaseProject)
    return (
      <FirebaseContext.Provider value={{auth, db}} >
        <ObserverContext.Provider value={{classCode: environment.classCode}} >
          <AuthProvider>
            <PreferencesProvider>
              <Router>
                <Switch>
                  <PrivateRoute
                    path="/scenario/:scenarioId"
                    authFlowLayout={UnauthedLayout}
                    component={Scenario}
                  />
                  <PrivateRoute
                    exact
                    path="/"
                    authFlowLayout={UnauthedLayout}
                    component={ScenarioList}
                  />
                </Switch>
              </Router>
            </PreferencesProvider>
          </AuthProvider>
        </ObserverContext.Provider>
      </FirebaseContext.Provider>
    )
}
